export default __webpack_public_path__ + "img/717111db5b91da3ec0da3ab27deefc60.png";